export default __webpack_public_path__ + "static/media/navbar_logo_mob.187abd12.svg";